module.exports = __webpack_public_path__ + "static/media/ball.fc1af361.png";